/**
 * Help panel per-option voice actions — call / email / chat / feature
 * request / raise ticket / schedule a meeting.
 *
 * Mounted from SupportOptions (renders only while the Help drawer is
 * open → naturally scoped). Each handler fires the SAME function the
 * manual list item fires, so voice and click converge.
 */

import { useCopilotAction } from "./actionRegistry";

const mk = (name, desc) =>
  Object.freeze({ name, description: desc, classification: "READ", parameters: [] });

const CALL = mk("help_call", "Implemented by noki-fe (tel: support number).");
const EMAIL = mk("help_email", "Implemented by noki-fe (mailto: support).");
const CHAT = mk("help_chat", "Implemented by noki-fe (open chat widget).");
const FEATURE = mk("help_feature_request", "Implemented by noki-fe (Canny feature board).");
const TICKET = mk("help_raise_ticket", "Implemented by noki-fe (Canny bug board).");
const SCHEDULE = mk("help_schedule_meeting", "Implemented by noki-fe (Calendly).");

export function useCopilotHelpOptionsActions({
  onCall,
  onEmail,
  onChat,
  onFeatureRequest,
  onRaiseTicket,
  onScheduleMeeting,
}) {
  const run = (fn, label) => async () => {
    if (typeof fn !== "function") {
      throw new Error(`host_exception: ${label} handler not wired.`);
    }
    fn();
    return { triggered: label };
  };

  useCopilotAction(CALL, run(onCall, "help_call"));
  useCopilotAction(EMAIL, run(onEmail, "help_email"));
  useCopilotAction(CHAT, run(onChat, "help_chat"));
  useCopilotAction(FEATURE, run(onFeatureRequest, "help_feature_request"));
  useCopilotAction(TICKET, run(onRaiseTicket, "help_raise_ticket"));
  useCopilotAction(SCHEDULE, run(onScheduleMeeting, "help_schedule_meeting"));
}
